export const DisplayStateEnum = {
    DAY: 0,
    MONTH: 1,
    YEAR: 2
};
